import React, { FC, ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import { Trans } from 'react-i18next';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { SubmitButton } from './';
import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'constants/index';
import { Index } from 'Links';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(3),
      marginTop: theme.spacing(6),
    },
    wrapper: {
      boxShadow: theme.custom.shadows.depth1,
      borderRadius: theme.spacing(5),
    },
    image: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    textContainer: {
      textAlign: 'center',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  message: ReactNode;
}

const FullScreenLayout: FC<IProps> = ({ classes, message }) => (
  <Grid container direction="column" justify="center" className={classes.container} spacing={3}>
    <Grid item>
      <img {...getAppImage(APP_IMAGES.Logo)} />
    </Grid>
    <Grid item>
      <div className={classes.wrapper}>
        <img className={classes.image} {...getAppImage(APP_IMAGES.Invalid)} />
        <Grid container className={classes.textContainer} spacing={5}>
          <Grid item xs={12}>
            {message}
          </Grid>
          <Grid item xs={12}>
            <SubmitButton component={Index} text={<Trans i18nKey="components:404Button" />} />
          </Grid>
        </Grid>
      </div>
    </Grid>
  </Grid>
);

export default withStyles(styles)(FullScreenLayout);
